/* eslint-disable jsx-a11y/label-has-associated-control */
import { Plus, X } from 'lucide-react';
import {
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
} from 'react-hook-form';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';

import { CoverageFormData } from '../types';

interface PolicyDetailsSectionProps {
  register: UseFormRegister<CoverageFormData>;
  policyDetailFields: FieldArrayWithId<
    CoverageFormData,
    'policy_details',
    'id'
  >[];
  appendPolicyDetail: UseFieldArrayAppend<CoverageFormData, 'policy_details'>;
  removePolicyDetail: UseFieldArrayRemove;
}

export const PolicyDetailsSection = ({
  register,
  policyDetailFields,
  appendPolicyDetail,
  removePolicyDetail,
}: PolicyDetailsSectionProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Additional Policy Details</CardTitle>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => appendPolicyDetail({ key: '', value: '' })}
          >
            <Plus className="h-4 w-4 mr-1" />
            Add Detail
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {policyDetailFields.map((field, index) => (
          <div key={field.id} className="grid grid-cols-2 gap-3 items-end">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Detail Name
              </label>
              <Input
                placeholder="e.g., Premium, Deductible, Effective Date"
                {...register(`policy_details.${index}.key`)}
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Detail Value
              </label>
              <div className="flex gap-2">
                <Input
                  placeholder="Detail value"
                  {...register(`policy_details.${index}.value`)}
                  className="flex-1"
                />
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => removePolicyDetail(index)}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        ))}

        {policyDetailFields.length === 0 && (
          <div className="text-center py-6 text-gray-500">
            <p>No policy details added yet.</p>
            <p className="text-sm">
              Click &quot;Add Detail&quot; to start adding policy-specific
              information.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
